import styled from 'styled-components';

export const ButtonGroupStyled = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  button {
    width: 200px;
  }
`;
